import React, { Fragment } from 'react';
import { DataTitleCopyable } from './data-title';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const DataPickerDataEntry = (props) => {
    let date = props.value == null ? null : new Date(props.value);
    return (React.createElement(Fragment, null,
        React.createElement(DataTitleCopyable, { slug: props.slug, slugModifier: props.slugModifier, title: props.title, tooltip: props.tooltip, disabled: props.disabled || props.value == undefined, copy: props.copy }),
        React.createElement("div", { className: "date-picker-input" },
            React.createElement(DatePicker, { showIcon: true, dateFormat: "dd/MM/yyyy", slug: props.slug, selected: date, onChange: e => {
                    props.onChange(props.slug, e === null ?
                        null :
                        e);
                }, title: props.tooltip, isClearable: !(props.mode === 'view' || props.disabled), placeholderText: "Select a date", maxDate: new Date(), disabled: props.mode === 'view' || props.disabled }))));
};
export default DataPickerDataEntry;
